import type { Location } from 'react-router-dom';

export type PrepareLinkData = string | number | null;

export interface PrepareLinkParams {
  location: Location;
  to?: string;
  query?: Record<string, string>;
  state?: Record<string, any>;
  keepOldQuery?: boolean;
  keepOldState?: boolean;
  keepOldPathname?: boolean;
  params?: Record<string, PrepareLinkData>;
}

export interface PreparedLink {
  pathname: string;
  search: string;
  state: Record<string, any>;
}

export function prepareLink({
  location,
  to = '',
  query = {},
  state = {},
  keepOldQuery = false,
  keepOldState = false,
  keepOldPathname = false,
  params = {},
}: PrepareLinkParams): PreparedLink {
  const pathname = keepOldPathname ? location.pathname + to : to || location.pathname;

  const newQuery = keepOldQuery ? new URLSearchParams(location.search) : new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    newQuery.append(key, value);
  });

  const newState = keepOldState ? { ...location.state, ...state } : state;

  return {
    pathname: Object.keys(params).length ? replaceWithParams(pathname, params) : pathname,
    search: newQuery.toString() ? `?${newQuery.toString()}` : '',
    state: newState,
  };
}

export function replaceWithParams(path: string, params: Record<string, PrepareLinkData>): string {
  const paramsKeys = Object.keys(params);

  if (!paramsKeys.length) {
    return path;
  }

  const pathParts: PrepareLinkData[] = path.split('/');

  for (const key of paramsKeys) {
    for (let i = 0; i < pathParts.length; i++) {
      if (pathParts[i] === `:${key}`) {
        pathParts[i] = params[key];
      }
    }
  }

  return pathParts.join('/');
}
